<template>
    <div class="news-detail">
    	<HeaderTop :activeIndex="activeIndex"></HeaderTop>
		<div class="news-detail-content">
			<div class="content">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item cursor"><a @click="goLogin">首页</a></li>
                        <li class="breadcrumb-item cursor"><a @click="goNews">新闻资讯</a></li>
                        <li class="breadcrumb-item active" aria-current="page">新闻详情</li>
                    </ol>
                </nav>
				<div class="content-title">
					<h3 class="title">{{notices.title}}</h3>
					<p class="time">发布时间:{{notices.publishTime|dateFormat}}</p>
				</div>
				<div class="content-explain">
					<div v-html="notices.content"></div>
				</div>
			</div>
		</div>
        <Footer></Footer>
	</div>
</template>

<script>
import HeaderTop from "./HeaderTop.vue";
import Footer from "./Footer.vue";

export default {
    name: 'NewsDetail',
    components: {
        Footer,
        HeaderTop
    },
	data() {
		return {
			activeIndex: 'newyear-news',
      notices:'',
		};
	},
  mounted() {
    this.getNotice()
  },
	methods: {
    async getNotice() {
      let id = this.$route.query.id
      await this.axios.get(`portal/notice/${id}`).then((res)=>{
        this.notices = res.data
      })
    },
    goLogin() {
      this.$router.push({ name: 'Login' })
    },
    goNews() {
      this.$router.push({ name: 'News' })
    }
	},
}
</script>

<style lang="scss" scoped>
::v-deep(.header-top .nav){
  background-color: #930B00;
}
.breadcrumb {
	background-color: #FFFFFF;
}
.breadcrumb > li + li:before {
  content: ">";
}
.cursor {
  cursor: pointer;
}
.news-detail {
	background-color: #FFFFFF;
	.news-detail-head {
		background-color: #FFFFFF;
		background: url("../../assets/home_icon01.png");
		.head-mid {
			width: 1200px;
			margin: 0 auto;
			.logo {
				float: left;
				height: 48px;
				margin: 26px 0;
				margin-right: 20px;
			}
			.ptname {
				float: left;
				font-size: 24px;
				color: #333;
				line-height: 100px;
				display: block;
			}
			.xzli {
				float: right;
				font-size: 14px;
				color: #333333;
				line-height: 30px;
				margin: 35px 0 35px 50px;
				cursor: pointer;
				.ticon{
					display: inline-block;
					vertical-align: middle;
					margin-bottom: 2px;
					margin-right: 5px;
				}
			}
		}
	}
	.news-detail-nav {
		background-color: #1965a2;
		.nav-mid {
			width: 1200px;
			margin: 0 auto;
			.el-menu {
				background-color: #1965a2;
				border-bottom: none;
				.el-menu-item {
					width: 150px;
					text-align: center;
				}
				.el-menu-item:hover {
					background-color: rgb(0,55,154);
				}
				.el-menu-item.is-active {
					border-bottom: none;
					color: #1965a2;
					background-color: #EEf6FF;
				}
				.adult {
					display: flex;
					padding: 0;
					width: 276px;
					border: none;
					font-size: 26px;
					font-weight: bold;
          			margin-left: 60px;
					:nth-child(1) {
						width: 60px;
						background: linear-gradient(-45deg, #ffa400 50%, #1965a2 50%);
					}
					:nth-child(2) {
						background-color: #ffa400;
					}
					:nth-child(3) {
						width: 60px;
						background: linear-gradient(135deg, #ffa400 50%, #1965a2 50%);
					}
				}
			}
		}
	}
	.news-detail-content {
		width: 1200px;
		margin: 0 auto;
        margin-top: 60px;
		.content {
			background-color: #FFFFFF;
			width: 100%;
			.content-title {
				padding: 40px 0 0 0;
				.title {
					font-size: 30px;
					font-weight: 400;
					color: #333333;
					line-height: 60px;
					text-align: center;
				}
				.time {
                    height: 60px;
					font-size: 16px;
					text-align: center;
					color: #333;
					line-height: 60px;
					font-weight: 400;
                    background-color: #FFF6E7;
				}
			}
      .content-explain {
        line-height: 35px;
        margin: 5px;
      }
		}
	}
}
</style>